import { render, staticRenderFns } from "./page-loader-cmp.vue?vue&type=template&id=1115c78a&scoped=true&"
import script from "./page-loader-cmp.vue?vue&type=script&lang=js&"
export * from "./page-loader-cmp.vue?vue&type=script&lang=js&"
import style0 from "./page-loader-cmp.vue?vue&type=style&index=0&id=1115c78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115c78a",
  null
  
)

export default component.exports